import axios from 'axios';
import appSettings from '../appSettings';

export const getPartners = async (partner) => {
  return await axios.get(
    `${appSettings.GET_PARTNER_DETAILS_URL}&partner=${partner}`
  );
};
